import DrawerNavigator from "./DrawerNavigator";
import { Outlet, Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const Layout = () => {
  // const user = Cookies.get("user");
  const user = sessionStorage.getItem("user");
  const token = Cookies.get("token");

  // If either user or token is missing, redirect to login
  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
      <DrawerNavigator>
        <Outlet />
      </DrawerNavigator>
    </div>
  );
};

export default Layout;
